// GOOGLE ANALYTICS 4 — Google's own gtag.js snippet, done from the bundle
// rather than pasted into index.html. An inline <script> would need
// 'unsafe-inline' (or a hash that changes on every edit) the day this page is
// served under a strict script-src; loading gtag.js from here needs only
// https://www.googletagmanager.com, which the deploy names in SECURITY__SCRIPTSRC.
//
// PAGE VIEWS ON NAVIGATION ARE GA'S, NOT OURS. Enhanced measurement's "page
// changes based on browser history events" (on by default for a web stream)
// records every client-side route change, so there is no router hook here —
// adding one as well would count each page twice.
export function startAnalytics(measurementId) {
    if (!measurementId || typeof document === 'undefined') return;

    window.dataLayer = window.dataLayer || [];
    // gtag.js reads the `arguments` object off the queue, not an array — the
    // exact shape of Google's snippet, so it stays a plain function.
    window.gtag = function gtag() {
        window.dataLayer.push(arguments);
    };
    window.gtag('js', new Date());
    window.gtag('config', measurementId);

    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(measurementId)}`;
    document.head.appendChild(script);
}
